import { IPostProjectButtonPanelRequest } from "../interfaces/api-requests/post-project-button-panel-request.interface";
import { IPutProjectButtonPanelRequest } from "../interfaces/api-requests/put-project-button-panel-request.interface";
import { IItem } from "../interfaces/items/item.interface";
import { IButtonPanelPrice } from "../interfaces/project/button-panel-price.interface";
import { IProjectButtonPanelHeading } from "../interfaces/project/project-button-panel-heading.interface";
import { IProjectButtonPanelItem } from "../interfaces/project/project-button-panel-item.interface";
import { IProjectButtonPanel } from "../interfaces/project/project-button-panel.interface";
import { IProjectComponent } from "../interfaces/project/project-component.interface";

export class ProjectButtonPanel implements IProjectButtonPanel {

    // todo: da gestirne la visibilità
    public idProject: number;
    public idButtonPanelFamily: number;
    public idButtonPanelTypology: number;
    public isCustomName: boolean;
    public box?: boolean;
    public idFixingTypology?: number;
    public idScrewTypology?: number;
    public pivotsQuantity?: number;
    public screwsQuantity?: number;
    public idOrientation: number;
    public width: number;
    public height: number;
    public widthSetByUser: boolean;
    public heightSetByUser: boolean;
    public holesInteraxe?: number;
    public holesInteraxeHorizontal?: number;
    public verticalInteraxeSetByUser: boolean;
    public horizontalInteraxeSetByUser: boolean;
    public topMargin: number;
    public topMarginSetByUser: boolean;
    public bottomMargin: number;
    public bottomMarginSetByUser: boolean;
    public idFinishing: number;
    public buttonsQuantity: number;
    public callButtonsQuantity: number;
    public serviceButtonsQuantity: number;
    public columnsQuantity: number;
    public serviceColumnsQuantity?: number;
    public idButtonFamily: number;
    public addBrailleTag: boolean;
    public brailleTagQuantity?: number;
    public addDisplay: boolean;
    public displayQuantity?: number;
    public idDisplayTypology?: number;
    public idHoleTypologyDisplay?: number | null;
    public idOrientationDisplay?: number | null;
    public addEmergencyLight: boolean;
    public emergencyLightQuantity?: number;
    public idEmergencyLightTypology?: number;
    public idHoleTypologyEmergencyLight?: number | null;
    public idOrientationEmergencyLight?: number | null;
    public addGrid: boolean;
    public gridQuantity?: number;
    public idGridTypology?: number;
    public addSpeakerKit: boolean;
    public arrowUpQuantity?: number;
    public arrowDownQuantity?: number;
    public idArrowTypology?: number;
    public addBip?: boolean;
    public addSercarEasy?: boolean;
    public addSintesi?: boolean;
    public addLogo: boolean;
    public idLogoTypology?: number;
    public logoWidth?: number;
    public logoHeight?: number;
    public graphicData?: string;
    public idButtonPanelStandard?: number;
    public items?: IProjectButtonPanelItem[];
    public reportImageUrl?: string;
    public holesNumber?: number;
    public bend1Value?: number;
    public bend2Value?: number;
    public idSheetMetal?: number;
    public price?: IButtonPanelPrice;

    get idProjectButtonPanel(): number {
        if (!this._idProjectButtonPanel) {
            throw new Error("Cannot be null here");
        } else {
            return this._idProjectButtonPanel;
        }
    }

    get quantity(): number {
        return this._quantity;
    }

    get itemsForSummary(): IItem[] | undefined {
        if (this.items) {
            let summaryItems: IItem[] = [];
            this.items.forEach(item => {
                summaryItems.push({
                    idItem: item.idItem,
                    navCode: '',
                    methodCode: item.methodCode,
                    description: item.description,
                    quantity: item.quantity,
                    unitPrice: item.appliedPrice ?? null,
                    totalPrice: item.totalPrice ?? null
                });
            });
            return summaryItems;
        } else {
            return undefined;
        }
    }

    constructor(
        private _idProjectButtonPanel: number | undefined,
        public name: string,
        public completed: boolean,
        private _quantity: number
    ) {
        this.idProject = 0;
        this.idButtonPanelFamily = 0;
        this.idButtonPanelTypology = 0;
        this.isCustomName = false;
        this.idOrientation = 0;
        this.width = 0;
        this.height = 0;
        this.widthSetByUser = false;
        this.heightSetByUser = false;
        this.holesInteraxe = 0;
        this.holesInteraxeHorizontal = 0;
        this.verticalInteraxeSetByUser = false;
        this.horizontalInteraxeSetByUser = false;
        this.topMargin = 0;
        this.topMarginSetByUser = false;
        this.bottomMargin = 0;
        this.bottomMarginSetByUser = false;
        this.idFinishing = 0;
        this.buttonsQuantity = 0;
        this.callButtonsQuantity = 0;
        this.serviceButtonsQuantity = 0;
        this.columnsQuantity = 0;
        this.idButtonFamily = 0;
        this.addBrailleTag = false;
        this.addDisplay = false;
        this.addEmergencyLight = false;
        this.addGrid = false;
        this.addSpeakerKit = false;
        this.addLogo = false;
    }

    public setQuantity(quantity: number): void {
        this._quantity = quantity;
    }

    /**
     * Imposta l'id generato dal backend dopo la create.
     * Viene applicato solo se l'oggetto non ha ancora un id (runtime object creato lato client).
     */
    public assignCreatedId(id: number | undefined): void {
        if (id == null) { return; }
        // assegna solo se non già presente
        if ((this as any)._idProjectButtonPanel === undefined) {
            (this as any)._idProjectButtonPanel = id; // cast per aggirare la private (limite TS a runtime)
        }
    }

    public updateFromFormData(formData: IPostProjectButtonPanelRequest | IPutProjectButtonPanelRequest): void {
        this._quantity = formData.quantity ?? 0;
        this.idButtonPanelFamily = formData.idButtonPanelFamily ?? 0;
        this.idButtonPanelTypology = formData.idButtonPanelTypology ?? 0;
        this.isCustomName = formData.isCustomName ?? false;
        this.name = formData.name ?? '';
        this.box = formData.box ?? undefined;
        this.idFixingTypology = formData.idFixingTypology ?? undefined;
        this.idScrewTypology = formData.idScrewTypology ?? undefined;
        this.pivotsQuantity = formData.pivotsQuantity ?? undefined;
        this.screwsQuantity = formData.screwsQuantity ?? undefined;
        this.idOrientation = formData.idOrientation ?? 0;
        this.width = formData.width ?? 0;
        this.height = formData.height ?? 0;
        this.idFinishing = formData.idFinishing ?? 0;
        this.buttonsQuantity = formData.buttonsQuantity ?? 0;
        this.callButtonsQuantity = formData.callButtonsQuantity ?? 0;
        this.serviceButtonsQuantity = formData.serviceButtonsQuantity ?? 0;
        this.columnsQuantity = formData.columnsQuantity ?? 0;
        this.serviceColumnsQuantity = formData.serviceColumnsQuantity ?? undefined;
        this.idButtonFamily = formData.idButtonFamily ?? 0;
        this.addBrailleTag = formData.addBrailleTag ?? false;
        this.brailleTagQuantity = formData.brailleTagQuantity ?? undefined;
        this.addDisplay = formData.addDisplay ?? false;
        this.displayQuantity = formData.displayQuantity ?? undefined;
        this.idDisplayTypology = formData.idDisplayTypology ?? undefined;
        this.idHoleTypologyDisplay = formData.idHoleTypologyDisplay;
        this.idOrientationDisplay = formData.idOrientationDisplay;
        this.addEmergencyLight = formData.addEmergencyLight ?? false;
        this.emergencyLightQuantity = formData.emergencyLightQuantity ?? undefined;
        this.idEmergencyLightTypology = formData.idEmergencyLightTypology ?? undefined;
        this.idHoleTypologyEmergencyLight = formData.idHoleTypologyEmergencyLight;
        this.idOrientationEmergencyLight = formData.idOrientationEmergencyLight;
        this.addGrid = formData.addGrid ?? false;
        this.gridQuantity = formData.gridQuantity ?? undefined;
        this.idGridTypology = formData.idGridTypology ?? undefined;
        this.addSpeakerKit = formData.addSpeakerKit ?? false;
        this.arrowUpQuantity = formData.arrowUpQuantity ?? undefined;
        this.arrowDownQuantity = formData.arrowDownQuantity ?? undefined;
        this.idArrowTypology = formData.idArrowTypology ?? undefined;
        this.addBip = formData.addBip ?? undefined;
        this.addSercarEasy = formData.addSercarEasy ?? undefined;
        this.addSintesi = formData.addSintesi ?? undefined;
        this.addLogo = formData.addLogo ?? false;
        this.idLogoTypology = formData.idLogoTypology ?? undefined;
        this.logoWidth = formData.logoWidth ?? undefined;
        this.logoHeight = formData.logoHeight ?? undefined;
        this.holesNumber = formData.holesNumber ?? undefined;
        this.bend1Value = formData.bend1Value ?? undefined;
        this.bend2Value = formData.bend2Value ?? undefined;
        this.idSheetMetal = formData.idSheetMetal ?? undefined;
    }

    public getComponentTitle(): string {
        return this.name;
    }

    public formatToSectionItem(): IProjectComponent {
        return {
            id: this.idProjectButtonPanel,
            name: this.getComponentTitle(),
            completed: this.completed,
            quantity: this.quantity
        };
    }

    public formatToJson(): IProjectButtonPanel {
        return {
            idProjectButtonPanel: this._idProjectButtonPanel ?? 0,
            name: this.name,
            completed: this.completed,
            quantity: this.quantity,
            idProject: this.idProject,
            idButtonPanelFamily: this.idButtonPanelFamily,
            idButtonPanelTypology: this.idButtonPanelTypology,
            isCustomName: this.isCustomName,
            box: this.box,
            idFixingTypology: this.idFixingTypology,
            idScrewTypology: this.idScrewTypology,
            pivotsQuantity: this.pivotsQuantity,
            screwsQuantity: this.screwsQuantity,
            idOrientation: this.idOrientation,
            width: this.width,
            height: this.height,
            widthSetByUser: this.widthSetByUser,
            heightSetByUser: this.heightSetByUser,
            holesInteraxe: this.holesInteraxe,
            holesInteraxeHorizontal: this.holesInteraxeHorizontal,
            verticalInteraxeSetByUser: this.verticalInteraxeSetByUser,
            horizontalInteraxeSetByUser: this.horizontalInteraxeSetByUser,
            topMargin: this.topMargin,
            topMarginSetByUser: this.topMarginSetByUser,
            bottomMargin: this.bottomMargin,
            bottomMarginSetByUser: this.bottomMarginSetByUser,
            idFinishing: this.idFinishing,
            buttonsQuantity: this.buttonsQuantity,
            callButtonsQuantity: this.callButtonsQuantity,
            serviceButtonsQuantity: this.serviceButtonsQuantity,
            columnsQuantity: this.columnsQuantity,
            serviceColumnsQuantity: this.serviceColumnsQuantity,
            idButtonFamily: this.idButtonFamily,
            addBrailleTag: this.addBrailleTag,
            brailleTagQuantity: this.brailleTagQuantity,
            addDisplay: this.addDisplay,
            displayQuantity: this.displayQuantity,
            idDisplayTypology: this.idDisplayTypology,
            idHoleTypologyDisplay: this.idHoleTypologyDisplay,
            idOrientationDisplay: this.idOrientationDisplay,
            addEmergencyLight: this.addEmergencyLight,
            emergencyLightQuantity: this.emergencyLightQuantity,
            idEmergencyLightTypology: this.idEmergencyLightTypology,
            idHoleTypologyEmergencyLight: this.idHoleTypologyEmergencyLight,
            idOrientationEmergencyLight: this.idOrientationEmergencyLight,
            addGrid: this.addGrid,
            gridQuantity: this.gridQuantity,
            idGridTypology: this.idGridTypology,
            addSpeakerKit: this.addSpeakerKit,
            arrowUpQuantity: this.arrowUpQuantity,
            arrowDownQuantity: this.arrowDownQuantity,
            idArrowTypology: this.idArrowTypology,
            addBip: this.addBip,
            addSercarEasy: this.addSercarEasy,
            addSintesi: this.addSintesi,
            addLogo: this.addLogo,
            idLogoTypology: this.idLogoTypology,
            logoWidth: this.logoWidth,
            logoHeight: this.logoHeight,
            graphicData: this.graphicData,
            idButtonPanelStandard: this.idButtonPanelStandard,
            items: this.items,
            reportImageUrl: this.reportImageUrl,
            holesNumber: this.holesNumber,
            bend1Value: this.bend1Value,
            bend2Value: this.bend2Value,
            idSheetMetal: this.idSheetMetal
        };
    }

    static from(value: IProjectButtonPanel): ProjectButtonPanel {
        const projectButtonPanel = new ProjectButtonPanel(
            value.idProjectButtonPanel,
            value.name,
            value.completed,
            value.quantity
        );
        projectButtonPanel.idProject = value.idProject;
        projectButtonPanel.idButtonPanelFamily = value.idButtonPanelFamily;
        projectButtonPanel.idButtonPanelTypology = value.idButtonPanelTypology;
        projectButtonPanel.isCustomName = value.isCustomName;
        projectButtonPanel.box = value.box;
        projectButtonPanel.idFixingTypology = value.idFixingTypology;
        projectButtonPanel.idScrewTypology = value.idScrewTypology;
        projectButtonPanel.pivotsQuantity = value.pivotsQuantity;
        projectButtonPanel.screwsQuantity = value.screwsQuantity;
        projectButtonPanel.idOrientation = value.idOrientation;
        projectButtonPanel.width = value.width;
        projectButtonPanel.height = value.height;
        projectButtonPanel.idFinishing = value.idFinishing;
        projectButtonPanel.buttonsQuantity = value.buttonsQuantity;
        projectButtonPanel.callButtonsQuantity = value.callButtonsQuantity;
        projectButtonPanel.serviceButtonsQuantity = value.serviceButtonsQuantity;
        projectButtonPanel.columnsQuantity = value.columnsQuantity;
        projectButtonPanel.serviceColumnsQuantity = value.serviceColumnsQuantity ?? value.columnsQuantity;
        projectButtonPanel.idButtonFamily = value.idButtonFamily;
        projectButtonPanel.addBrailleTag = value.addBrailleTag;
        projectButtonPanel.brailleTagQuantity = value.brailleTagQuantity;
        projectButtonPanel.addDisplay = value.addDisplay;
        projectButtonPanel.displayQuantity = value.displayQuantity;
        projectButtonPanel.idDisplayTypology = value.idDisplayTypology;
        projectButtonPanel.idHoleTypologyDisplay = value.idHoleTypologyDisplay;
        projectButtonPanel.idOrientationDisplay = value.idOrientationDisplay;
        projectButtonPanel.addEmergencyLight = value.addEmergencyLight;
        projectButtonPanel.emergencyLightQuantity = value.emergencyLightQuantity;
        projectButtonPanel.idEmergencyLightTypology = value.idEmergencyLightTypology;
        projectButtonPanel.idHoleTypologyEmergencyLight = value.idHoleTypologyEmergencyLight;
        projectButtonPanel.idOrientationEmergencyLight = value.idOrientationEmergencyLight;
        projectButtonPanel.addGrid = value.addGrid;
        projectButtonPanel.gridQuantity = value.gridQuantity;
        projectButtonPanel.idGridTypology = value.idGridTypology;
        projectButtonPanel.addSpeakerKit = value.addSpeakerKit;
        projectButtonPanel.arrowUpQuantity = value.arrowUpQuantity;
        projectButtonPanel.arrowDownQuantity = value.arrowDownQuantity;
        projectButtonPanel.idArrowTypology = value.idArrowTypology;
        projectButtonPanel.addBip = value.addBip;
        projectButtonPanel.addSercarEasy = value.addSercarEasy;
        projectButtonPanel.addSintesi = value.addSintesi;
        projectButtonPanel.addLogo = value.addLogo;
        projectButtonPanel.idLogoTypology = value.idLogoTypology;
        projectButtonPanel.logoWidth = value.logoWidth;
        projectButtonPanel.logoHeight = value.logoHeight;
        projectButtonPanel.graphicData = value.graphicData;
        projectButtonPanel.idButtonPanelStandard = value.idButtonPanelStandard;
        projectButtonPanel.items = value.items;
        projectButtonPanel.reportImageUrl = value.reportImageUrl;
        projectButtonPanel.holesNumber = value.holesNumber;
        projectButtonPanel.bend1Value = value.bend1Value;
        projectButtonPanel.bend2Value = value.bend2Value;
        projectButtonPanel.idSheetMetal = value.idSheetMetal;
        projectButtonPanel.price = value.price;
        return projectButtonPanel;
    }

    static fromHeading(value: IProjectButtonPanelHeading): ProjectButtonPanel {
        return new ProjectButtonPanel(
            value.idProjectButtonPanel,
            value.name,
            value.completed,
            value.quantity
        );
    }

    static isProjectButtonPanelHeading(value: IProjectButtonPanelHeading | IProjectButtonPanel): value is IProjectButtonPanelHeading {
        return (value as IProjectButtonPanel).idButtonPanelFamily === undefined;
    }

    static isProjectButtonPanel(value: IProjectButtonPanelHeading | IProjectButtonPanel): value is IProjectButtonPanel {
        return (value as IProjectButtonPanel).idButtonPanelFamily !== undefined;
    }

    static toDuplicatePostRequest(source: IProjectButtonPanel, duplicateName: string, idProject: number): IPostProjectButtonPanelRequest {
        const serviceColumnsQuantity = source.serviceColumnsQuantity ?? source.columnsQuantity ?? 1;

        return {
            idProject,
            idButtonPanelFamily: source.idButtonPanelFamily,
            idButtonPanelTypology: source.idButtonPanelTypology,
            name: duplicateName,
            isCustomName: true,
            box: source.box,
            idFixingTypology: source.idFixingTypology,
            idScrewTypology: source.idScrewTypology,
            pivotsQuantity: source.pivotsQuantity,
            screwsQuantity: source.screwsQuantity,
            idOrientation: source.idOrientation,
            width: source.width,
            height: source.height,
            widthSetByUser: source.widthSetByUser,
            heightSetByUser: source.heightSetByUser,
            holesInteraxe: source.holesInteraxe,
            holesInteraxeHorizontal: source.holesInteraxeHorizontal,
            verticalInteraxeSetByUser: source.verticalInteraxeSetByUser,
            horizontalInteraxeSetByUser: source.horizontalInteraxeSetByUser,
            topMargin: source.topMargin,
            topMarginSetByUser: source.topMarginSetByUser,
            bottomMargin: source.bottomMargin,
            bottomMarginSetByUser: source.bottomMarginSetByUser,
            idFinishing: source.idFinishing,
            buttonsQuantity: source.buttonsQuantity,
            callButtonsQuantity: source.callButtonsQuantity,
            serviceButtonsQuantity: source.serviceButtonsQuantity,
            columnsQuantity: source.columnsQuantity,
            serviceColumnsQuantity,
            idButtonFamily: source.idButtonFamily,
            addBrailleTag: source.addBrailleTag,
            brailleTagQuantity: source.brailleTagQuantity,
            addDisplay: source.addDisplay,
            displayQuantity: source.displayQuantity,
            idDisplayTypology: source.idDisplayTypology,
            idHoleTypologyDisplay: source.idHoleTypologyDisplay,
            idOrientationDisplay: source.idOrientationDisplay,
            addEmergencyLight: source.addEmergencyLight,
            emergencyLightQuantity: source.emergencyLightQuantity,
            idEmergencyLightTypology: source.idEmergencyLightTypology,
            idHoleTypologyEmergencyLight: source.idHoleTypologyEmergencyLight,
            idOrientationEmergencyLight: source.idOrientationEmergencyLight,
            addGrid: source.addGrid,
            gridQuantity: source.gridQuantity,
            idGridTypology: source.idGridTypology,
            addSpeakerKit: source.addSpeakerKit,
            arrowUpQuantity: source.arrowUpQuantity,
            arrowDownQuantity: source.arrowDownQuantity,
            idArrowTypology: source.idArrowTypology,
            addBip: source.addBip,
            addSercarEasy: source.addSercarEasy,
            addSintesi: source.addSintesi,
            addLogo: source.addLogo,
            idLogoTypology: source.idLogoTypology,
            logoWidth: source.logoWidth,
            logoHeight: source.logoHeight,
            quantity: source.quantity,
            graphicData: source.graphicData,
            idButtonPanelStandard: source.idButtonPanelStandard,
            items: source.items?.map(item => ({ ...item })),
            clearAllItems: false,
            addHoles: !!source.holesNumber,
            holesNumber: source.holesNumber,
            cutPerimeter: source.cutPerimeter,
            bend1Value: source.bend1Value,
            bend2Value: source.bend2Value,
            idSheetMetal: source.idSheetMetal,
        };
    }

}
